export const usd = (v) => {
  const n = Number(v || 0);
  if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(1)}K`;
  if (n === 0) return "$0";
  return `$${n.toFixed(n < 1 ? 4 : 0)}`;
};

export const price = (v) => {
  const n = Number(v || 0);
  if (n === 0) return "$0";
  if (n < 0.0001) {
    const s = n.toExponential(3);
    return `$${s}`;
  }
  return `$${n.toFixed(6)}`;
};

export const age = (ts) => {
  if (!ts) return "-";
  const s = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}dk`;
  if (s < 86400) return `${Math.floor(s / 3600)}sa`;
  return `${Math.floor(s / 86400)}g`;
};

export const eth = (v, d = 5) => `${Number(v || 0).toFixed(d)} Ξ`;

export const short = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

export const pct = (bps) => (bps == null ? "-" : `${(bps / 100).toFixed(1)}%`);

export const EXPLORER = "https://robin.etherscan.io";
